import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendCorrections } from '../services/IIMIssuesService';
import { iimReviewKeys } from './queryKeys';
/**
 * Hook for sending corrections for an IIM run
 * This will trigger the generation of proposed corrections based on marked issues
 * @param inspectionId - The inspection ID to invalidate queries for
 * @param runId - The run ID to send corrections for
 * @returns Mutation object for sending corrections
 */
export default function useSendCorrections(inspectionId, runId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ generalManagerNote, issuesCount }) => sendCorrections(runId, generalManagerNote, issuesCount),
        // Invalidate queries after successful mutation
        onSuccess: () => {
            // Invalidate ALL issues queries for this inspection, not just the current status filter
            void queryClient.invalidateQueries({ queryKey: iimReviewKeys.issuesAll(inspectionId) });
        }
    });
}
